import React from 'react'

import Ticket from '@components/Ticket'
import useMain from '@hooks/useMain'
import { TicketSectionContainer } from '@styles/layouts/home/TicketSection/styles'

const TicketSection: React.FC = () => {
    const {
        state: { selectedSalesBehaviour },
    } = useMain()
    return (
        <TicketSectionContainer>
            <Ticket assetUrl={selectedSalesBehaviour?.assetUrl || ''} />
        </TicketSectionContainer>
    )
}

export default TicketSection
